// import { createContext, useContext, useState, useEffect } from "react";

// const AuthContext = createContext();

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [loading, setLoading] = useState(true); // 👈 loading state

//   useEffect(() => {
//     const access = localStorage.getItem("access");
//     if (access) {
//       setIsAuthenticated(true);
//     }
//     setLoading(false); // 👈 finish loading once check is done
//   }, []);

//   const login = () => {
//     setIsAuthenticated(true);
//   };

//   const logout = () => {
//     localStorage.removeItem("access");
//     localStorage.removeItem("refresh");
//     localStorage.clear();
//     setIsAuthenticated(false);
//   };

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };




// // src/components/authentication/AuthContext.js
// import { createContext, useContext, useState, useEffect } from "react";

// const AuthContext = createContext(null);

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [userData, setUserData] = useState(null); // State to store the full user data object
//   const [userRole, setUserRole] = useState('loading'); // State to store the determined role ('loading', 'public', 'user', 'vendor')
//   // New states for vendor-specific flags, extracted from userData
//   const [canPostDeals, setCanPostDeals] = useState(false);
//   const [kycStatus, setKycStatus] = useState(null); // e.g., 'not_submitted', 'pending', 'approved', 'rejected'

//   // Helper function to derive userRole from userData
//   const determineUserRole = (data) => {
//     if (!data) return 'public';

//     // Check for vendor first, as a vendor might also have user.id
//     // CURRENT CHECK: if (data.vendor_id && data.vendor_id !== "")
//     if (data.vendor_id && data.vendor_id !== "") { // This condition IS met based on your response!
//       return 'vendor';
//     }
//     // Check for regular user or social user
//     else if (data.user && data.user.id) {
//       return 'user';
//     }
//     return 'public';
//   };

//   const extractVendorSpecificData = (data, role) => {
//     if (role === 'vendor' && data) {
//       // CURRENT CHECKS: data.can_post_deals, data.kyc_status
//       // Your response has "is_approved": false, but NO "can_post_deals" or "kyc_status"
//       setCanPostDeals(data.can_post_deals === true); // This will be undefined === true, so false
//       setKycStatus(data.kyc_status || 'not_submitted'); // This will be undefined || 'not_submitted', so 'not_submitted'
//     } else {
//       setCanPostDeals(false);
//       setKycStatus(null);
//     }
//   };

//   useEffect(() => {
//     const access = localStorage.getItem("access");
//     const storedUserDataString = localStorage.getItem("userData"); // Get the full user data string

//     if (access && storedUserDataString) {
//       try {
//         const parsedUserData = JSON.parse(storedUserDataString);
//         setUserData(parsedUserData);
//         setIsAuthenticated(true);
//         const role = determineUserRole(parsedUserData);
//         setUserRole(role);

//         // Extract vendor-specific data if the role is 'vendor'
//         extractVendorSpecificData(parsedUserData, role);

//       } catch (error) {
//         console.error("Error parsing stored user data:", error);
//         // If parsing fails, treat as not authenticated
//         setIsAuthenticated(false);
//         setUserData(null);
//         setUserRole('public');
//         setCanPostDeals(false);
//         setKycStatus(null);
//       }
//     } else {
//       // No access token or user data, so default to public/unauthenticated
//       setIsAuthenticated(false);
//       setUserData(null);
//       setUserRole('public');
//       setCanPostDeals(false);
//       setKycStatus(null);
//     }
//     setLoading(false); // Finish loading regardless of auth status
//   }, []);

//   // Modify the login function to accept and store full user data
//   const login = (data) => {
//     // 'data' is expected to be the full JSON response from your login API
//     if (data && data.access) { // Ensure an access token is present
//       localStorage.setItem("access", data.access);
//       if (data.refresh) {
//         localStorage.setItem("refresh", data.refresh);
//       }
//       localStorage.setItem("userData", JSON.stringify(data)); // Store the entire response

//       setIsAuthenticated(true);
//       setUserData(data);
//       const role = determineUserRole(data);
//       setUserRole(role);

//       // Extract vendor-specific data immediately on login
//       extractVendorSpecificData(data, role);

//     } else {
//       console.error("Login data missing access token or invalid format:", data);
//       // If login data is invalid, log out to ensure a clean state
//       logout();
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem("access");
//     localStorage.removeItem("refresh");
//     localStorage.removeItem("userData"); // Also clear userData from localStorage
//     // Optional: localStorage.clear(); // Use this ONLY if you want to clear ALL localStorage data
//     setIsAuthenticated(false);
//     setUserData(null);
//     setUserRole('public'); // Reset role on logout
//     setCanPostDeals(false); // Reset vendor-specific data
//     setKycStatus(null);     // Reset vendor-specific data
//   };

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, login, logout, loading, userData, userRole, canPostDeals, kycStatus }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// src/components/Authentication/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // True initially while checking localStorage
  const [userData, setUserData] = useState(null);
  const [userRole, setUserRole] = useState('loading'); // 'loading' while checking, then 'public', 'user', or 'vendor'

  const [canPostDeals, setCanPostDeals] = useState(false);
  const [kycStatus, setKycStatus] = useState(null);

  const determineUserRole = (data) => {
    if (!data) {
      return 'public';
    }
    if (data.vendor_id && data.vendor_id !== "") {
      return 'vendor';
    }
    else if (data.user && data.user.id) {
      return 'user';
    }
    return 'public';
  };

  const extractVendorSpecificData = (data, role) => {
    if (role === 'vendor' && data) {
      setCanPostDeals(data.is_approved === true);
      setKycStatus(data.kyc_status || (data.is_approved ? 'approved' : 'not_submitted'));
    } else {
      setCanPostDeals(false);
      setKycStatus(null);
    }
  };

  useEffect(() => {
    const access = localStorage.getItem("access");
    const refresh = localStorage.getItem("refresh");
    const storedUserDataString = localStorage.getItem("userData");

    if (access && storedUserDataString) {
      try {
        const parsedUserData = JSON.parse(storedUserDataString);
        setUserData(parsedUserData);
        setIsAuthenticated(true);
        const role = determineUserRole(parsedUserData);
        setUserRole(role);

        extractVendorSpecificData(parsedUserData, role);

      } catch (error) {
        logout(); // Logout if stored data is corrupt
      }
    } else {
      setIsAuthenticated(false);
      setUserData(null);
      setUserRole('public'); // Explicitly set to 'public'
      setCanPostDeals(false);
      setKycStatus(null);
    }
    setLoading(false); // Finish loading regardless of auth status
  }, []); // Empty dependency array means this runs once on mount

  const login = (data) => {
    if (data && data.access) {
      localStorage.setItem("access", data.access);
      if (data.refresh) {
        localStorage.setItem("refresh", data.refresh);
      }
      localStorage.setItem("userData", JSON.stringify(data));

      setIsAuthenticated(true);
      setUserData(data);
      const role = determineUserRole(data);
      setUserRole(role);

      extractVendorSpecificData(data, role);

    } else {
      logout();
    }
  };

  const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("userData");
    setIsAuthenticated(false);
    setUserData(null);
    setUserRole('public'); // Reset role on logout
    setCanPostDeals(false);
    setKycStatus(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading, userData, userRole, canPostDeals, kycStatus }}>
      {children}
    </AuthContext.Provider>
  );
};















// src/contexts/AuthContext.js

// import React, { createContext, useContext, useState, useEffect } from "react";

// const AuthContext = createContext();

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [userRole, setUserRole] = useState("public"); // Default to 'public'
//   const [kycStatus, setKycStatus] = useState("not_submitted"); // Default KYC status
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const access = localStorage.getItem("access");
//     const storedUserRole = localStorage.getItem("userRole");
//     const storedKycStatus = localStorage.getItem("kycStatus");

//     if (access) {
//       setIsAuthenticated(true);
//       setUserRole(storedUserRole || "user"); // Default to 'user' if role not set
//       setKycStatus(storedKycStatus || "not_submitted"); // Default KYC status
//     } else {
//       // If no access token, ensure user is public
//       setIsAuthenticated(false);
//       setUserRole("public");
//       setKycStatus("not_submitted");
//     }
//     setLoading(false);
//   }, []);

//   const login = (role, kycStat = "not_submitted") => {
//     // Assuming 'access' token is stored in localStorage by your actual login API call
//     // localStorage.setItem("access", "your_access_token"); // This should come from your API response
//     localStorage.setItem("userRole", role);
//     localStorage.setItem("kycStatus", kycStat); // Initial KYC status on login
//     setIsAuthenticated(true);
//     setUserRole(role);
//     setKycStatus(kycStat);
//   };

//   const logout = () => {
//     localStorage.removeItem("access");
//     localStorage.removeItem("refresh");
//     localStorage.removeItem("userRole"); // Remove userRole on logout
//     localStorage.removeItem("kycStatus"); // Remove kycStatus on logout
//     // localStorage.clear(); // Use this if you want to clear ALL localStorage items
//     setIsAuthenticated(false);
//     setUserRole("public");
//     setKycStatus("not_submitted");
//   };

//   const updateKycStatus = (status) => {
//     setKycStatus(status);
//     localStorage.setItem("kycStatus", status);
//     if (status === "approved") {
//       setUserRole("vendor"); // If KYC approved, update role to vendor
//       localStorage.setItem("userRole", "vendor");
//     }
//   };

//   // Derived states for easier checks
//   const isPublic = !isAuthenticated;
//   const isRegularUser = isAuthenticated && userRole === "user";
//   const isVendor = isAuthenticated && userRole === "vendor";
//   const canPostDeals = isVendor && kycStatus === "approved";
//   const canPostActivities = isAuthenticated && (userRole === "user" || userRole === "vendor");


//   const contextValue = {
//     isAuthenticated,
//     userRole,
//     kycStatus,
//     loading,
//     login,
//     logout,
//     updateKycStatus,
//     isPublic,
//     isRegularUser, // Renamed from isUser to avoid confusion with public user
//     isVendor,
//     canPostDeals,
//     canPostActivities,
//   };

//   return (
//     <AuthContext.Provider value={contextValue}>
//       {children}
//     </AuthContext.Provider>
//   );
// };